/**
 * AppStoreModule
 *
 * A module in order to share data across components.
 *
 * example: create new instance

 new AppStoreModule().init({
    appConfig,
    proxyPath,
});

 *
 * Note: since some of the data is fetched asynchronously
 * the data from the module might not be set when a component is rendered
 * we need to recursively check if there is an instance of the module
 *
 * example: get instance
    import AppStoreModule from '../AppStoreModule';

    const getInstance = () => {
      return AppStoreModule.getInstance();
    };

    const asyncHasAppStoreInstance = (callback: any) => {
        utils.recursiveDetection(
                {
                    delay: 250,
                    maxTries: 4,
                    detectFunc: getInstance,
                },
                (response: any) => callback(response)
            );

        return;
    };

    useEffect(() => {
        // check if account AppStore has been set yet
        asyncHasAppStoreInstance((response: any) => {
            if (response) {
                setInstanceAppStore(response);
            } else {
                setInstanceAppStore(false);
            }
        });
    }, []);
 */

class AppStoreModule {
  static instance: AppStoreModule;

  appConfig: Record<string, unknown> = {};
  proxyPath: string = '';

  constructor() {
    if (!AppStoreModule.instance) {
      AppStoreModule.instance = this;
    }

    return AppStoreModule.instance;
  }

  init({ appConfig, proxyPath }: { appConfig: Record<string, unknown>; proxyPath: string }) {
    this.appConfig = appConfig;
    this.proxyPath = proxyPath;

    return AppStoreModule.instance;
  }

  static getInstance() {
    if (!AppStoreModule.instance) {
      // eslint-disable-next-line no-console
      console.warn('WARN:AppStoreModule: no instance created');
    }

    return AppStoreModule.instance;
  }

  getAppConfig() {
    return this.appConfig;
  }

  getProxyPath() {
    return this.proxyPath;
  }
}

export default AppStoreModule;
